import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, ValidationErrors } from '@angular/forms';

/** Custom Validator Function */
export function urlValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    try {
      new URL(control.value);
      return null;
    } catch (err) {
      return { invalidUrl: true };
    }
  };
}

@Directive({
  selector: '[isValidUrl]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: IsValidUrlDirective,
      multi: true
    }
  ]
})
export class IsValidUrlDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return urlValidator()(control);
  }
}


// WEBPACK FOOTER //
// ./src/app/directives/is-valid-url.directive.ts